import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { Data2Service } from 'src/app/services/data2.service';
import { Investment } from 'src/app/models/investment';
import { CommonModule } from '@angular/common';
import { SvgDefinitionsComponent } from "../../_components/svg-definitions/svg-definitions.component";
import { ChartEmbedComponent } from '../../_components/chart-embed/chart-embed.component';
import { ImplementationsService } from 'src/app/services/implementations.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PortfolioSideNavigationComponent } from "../_components/portfolio-side-navigation/portfolio-side-navigation.component";
import { PortfolioAllocationComponent } from "../_components/portfolio-allocation/portfolio-allocation.component";
import { PortfolioBannerWithNavComponent } from "../_components/portfolio-banner-with-nav/portfolio-banner-with-nav.component";
import { PortfolioParserService } from 'src/app/services/portfolio-parser.service';
import { ExclusionList } from 'src/app/models/exclusion-list';
import { ExclusionsListService } from 'src/app/services/exclusions-list.service';
import { SafePipe } from 'src/app/pipes/safe.pipe';

@Component({
  selector: 'app-portfolio-mixed',
  imports: [CommonModule,
    RouterModule,
    SafePipe,
    ChartEmbedComponent,   
    SvgDefinitionsComponent,
    FontAwesomeModule, 
    PortfolioSideNavigationComponent, 
    PortfolioAllocationComponent, 
    PortfolioBannerWithNavComponent],
  templateUrl: './portfolio-mixed.component.html',
  styleUrl: './portfolio-mixed.component.scss'
})
export class PortfolioMixedComponent {
  
    exclusions: ExclusionList[]
defsLoaded=false;
  params:any = {}
  equity:number =50;
  portfolioNumber:string|null = null;
  investmentSymbol:string|null = null; //port100cp_ifa
  investment:Investment|null|any = null;
  showMixDropDown=false;
  showAllocation=false;
  s=1;
  b=1;

  pre = 'port';
  post = 'sr_ifa';

  pballClick(){
    console.log("pballclick"  )
    this.showAllocation=!this.showAllocation;
  }
  pballClick2(){
    console.log("pballclick2"  )
      // this.router.navigate([`/portfolios/${this.equity}/implementation/mix/s${this.s}-b${this.b}-${this.equity}`],{fragment:"results"});  
       //https://www.ifa.com/portfolios/90/implementation/mix/s1-b1-90#results
  }
  portBallNavChange(evt:any){
     this.cdr.detectChanges();
  }

  charts = [
  
    {id:689, title:"Risk and Return Data",imageUrl:'https://data.ifa.com/content/charts/689/thumbnail_177w_100h_.png'},
    {id:690, title:"SPIEs", imageUrl:'https://data.ifa.com/content/charts/690/thumbnail_177w_100h_.png'},
  //  {id:154, title:"Year To Date Returns",imageUrl:'https://data.ifa.com/content/charts/154/thumbnail_177w_100h_.png'},
    {id:250, title:"Year To Date Returns",imageUrl:'https://data.ifa.com/content/charts/250/thumbnail_177w_100h_.png'},
     {id:45, title:"Risk Return Scatter Plot",imageUrl:'https://data.ifa.com/content/charts/45/thumbnail_177w_100h_.png'},
    // {id:123, title:"Why Diversify? Stocks",imageUrl:'https://data.ifa.com/content/charts/123/thumbnail_177w_100h_.png'},
     {id:255, title:"Histograms of Simulated Experiences",imageUrl:'https://data.ifa.com/content/charts/255/thumbnail_177w_100h_.png'},
     {id:91, title:"Monthly Rolling Periods",imageUrl:'https://data.ifa.com/content/charts/91/thumbnail_177w_100h_.png'},
     {id:254, title:"Distribution of Monthly Returns",imageUrl:'https://data.ifa.com/content/charts/254/thumbnail_177w_100h_.png'},
     {id:244, title:"Positive vs. Negative Returns",imageUrl:'https://data.ifa.com/content/charts/244/thumbnail_177w_100h_.png'},
     {id:94, title:"High-Median-Low %",imageUrl:'https://data.ifa.com/content/charts/94/thumbnail_177w_100h_.png'},
     {id:245, title:"Index Comparisons",imageUrl:'https://data.ifa.com/content/charts/245/thumbnail_177w_100h_.png'},
     {id:243, title:"Index Portfolio Comparisons",imageUrl:'https://data.ifa.com/content/charts/243/thumbnail_177w_100h_.png'},
     {id:253, title:"Roller Coaster of Risk and Returns",imageUrl:'https://data.ifa.com/content/charts/253/thumbnail_177w_100h_.png'},
     {id:263, title:"Style Drifters: Asset Classes",imageUrl:'https://data.ifa.com/content/charts/263/thumbnail_177w_100h_.png'},
    {id:85, title:"Stock Pickers: Dow Stocks",imageUrl:'https://data.ifa.com/content/charts/85/thumbnail_177w_100h_.png'},
    {id:84, title:"Style Drifters: Countries",imageUrl:'https://data.ifa.com/content/charts/84/thumbnail_177w_100h_.png'},
    // {url:'matrix', title:"Risk Return Matrix",imageUrl:"/assets/images/icons/portfolios/matrix_icon.png", renderChart:false},
    // {url:'top-ten-holdings', title:"Top Ten Holdings",imageUrl:'/assets/images/icons/portfolios/top10_icon.png',renderChart:false},
    // {url:'/calculator', title:"IFA Index Calculator",imageUrl:'/assets/images/icons/menu/calculator-ifa-index.png',renderChart:false},
    // {href:'https://www.ifa.com/pdfs/ifa-capitalism-inc.pdf', target:"_blank", title:"Capitalism, Inc.",imageUrl:'/assets/images/icons/portfolios/capitalism_icon.png',renderChart:false},
    
  ];
  

  constructor(
    private route:ActivatedRoute, 
     private router:Router, 
    public implementationService:ImplementationsService,
    private portfolioParserService:PortfolioParserService,
    private exlusionservice: ExclusionsListService,
    private cdr: ChangeDetectorRef
  ){

    this.params = this.route.snapshot.params;
    this.route.params.subscribe((params:any)=>{
      //console.log("mixer params",params)
      this.portfolioParserService.parsePortfolioMix(params['mixParam'] || params['id(\\d+)'])
        .subscribe((data)=>{
          //console.log("parsed mix data:",data)
          this.s = data.s;
          this.b = data.b;
          this.equity = data.equity;
          this.investmentSymbol = data.investmentSymbol;
          this.investment = data.investment;
          this.post = data.post;
          this.portfolioNumber=data.investment?.portfolionumber;

            this.cdr.detectChanges();
        });
     

                
             
  })

   this.exlusionservice.getExclusionsList().subscribe(resp => {         
      this.exclusions = resp;   
      this.cdr.detectChanges();
    })
  }


                  

}
